import { createAction, props } from '@ngrx/store';

export const updateEtoken = createAction(
    '[AUTH] Update Etoken',
    props<{ etoken: string }>(),
);

export const resetEtoken = createAction('[AUTH] Reset Etoken');
